import { shape, required, Validator, Failure, Success, ValidationError, concatFailure, when, fromModel, stopOnFirstFailure } from '@totalsoft/pure-validations';
import i18next from 'i18next';
import { isTrue, isValidDateFormat } from 'utils/simple-validations';

export const uniqueItem = nonWorkingDayList =>
  Validator(nonWorkingDay => {
    if (!nonWorkingDayList) return Success;

    const duplicateNonWorkingDays = nonWorkingDayList.filter(
      x =>
        x.nonWorkingDayDate.split('T')[0] === nonWorkingDay?.nonWorkingDayDate?.split('T')[0] &&
        x.workingSiteId === nonWorkingDay.workingSiteId &&
        x.nonWorkingDayId !== nonWorkingDay.nonWorkingDayId
    );

    if (duplicateNonWorkingDays.length === 0) return Success;

    for (const duplicate of duplicateNonWorkingDays) {
      const duplicateValidInAllContexts = duplicate.validInAllContexts;
      const nonWorkingDayValidInAllContexts = nonWorkingDay.validInAllContexts;

      if (duplicateValidInAllContexts && (!nonWorkingDay.contexts || nonWorkingDay.contexts.length > 0)) {
        return Failure(ValidationError(i18next.t('NonWorkingDays.DuplicateNonWorkingDayWithValidInAllContextsError')));
      }

      if (nonWorkingDayValidInAllContexts && duplicate.contexts && duplicate.contexts.length) {
        return Failure(ValidationError(i18next.t('NonWorkingDays.DuplicateNonWorkingDayContextError')));
      }

      if (!nonWorkingDayValidInAllContexts && nonWorkingDay.contexts && nonWorkingDay.contexts.length) {
        for (const contextId of nonWorkingDay.contexts) {
          if (duplicate.contexts.some(nwc => nwc === contextId)) {
            return Failure(ValidationError(i18next.t('NonWorkingDays.DuplicateNonWorkingDayContextError')));
          }
        }
      }
    }

    return Success;
  });

export const nonWorkingDayValidator = nonWorkingDayList =>
  [
    fromModel(model => {
      return shape({
        nonWorkingDayDate: [required, isValidDateFormat] |> stopOnFirstFailure,
        workingSiteId: required,
        validInAllContexts:
          isTrue(i18next.t('NonWorkingDays.ContextRuleValidation')) |> when(!model.contexts || model.contexts.length === 0),
        contexts: required |> when(!model.validInAllContexts)
      });
    }),
    uniqueItem(nonWorkingDayList)
  ] |> concatFailure;
